import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store";
import "./app.css";
import "./styles/commonStyles.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

if (process.env.NODE_ENV !== "development") console.log = () => {};
if (process.env.NODE_ENV !== "development") console.error = () => {};
if (process.env.NODE_ENV !== "development") console.warn = () => {};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
